export const CONFIG = {
  API_BASE_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api/v1',
  WS_URL: (import.meta.env.VITE_WS_URL as string | undefined) ?? `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws/portal`,
  STRIPE_PUBLISHABLE_KEY: (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? '',
  /** Where the landing page's "Contact us" link goes. This mailbox MUST
   *  actually receive mail — a mailto: to a dead address loses enquiries
   *  silently, with nothing logged anywhere. */
  CONTACT_EMAIL: (import.meta.env.VITE_CONTACT_EMAIL as string | undefined) ?? 'contact@patrolit.org',

  /** Public demo credentials, prefilled by /login?demo=1. Deliberately
   *  public: the demo estate is disposable and demo_restore.sh puts it back.
   *  Must match the demo admin login, so re-snapshot after changing either. */
  DEMO_EMAIL: (import.meta.env.VITE_DEMO_EMAIL as string | undefined) ?? 'demo@patrolit.doggoes.org',
  DEMO_PASSWORD: (import.meta.env.VITE_DEMO_PASSWORD as string | undefined) ?? 'PatrolitDemo2026!',

  PAGINATION_PAGE_SIZE: 50,
  WS_BACKOFF_INITIAL_MS: 1_000 as number,
  WS_BACKOFF_MAX_MS: 30_000 as number,
};
